module.exports = __webpack_public_path__ + "img/block_03_img.a1ac3bdc.png";